import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'

import Modal from '../../../../UniformComponents/Modal'
import Button from '../../../../UniformComponents/Button'
import Input from '../../../form/Input'
import CheckboxGroup from '../../../form/CheckboxGroup'
import Select from '../../../form/Select'
import Switch from '../../../../UniformComponents/Switch'

const LicenceAllocation = observer((props) => {
    const { store, show, licenceAllocation } = props
    const { licenceGroups, clientProducts } = store

    const [licenceFeatures, setLicenceFeatures] = useState([])

    useEffect(() => {
        if (show) {
            let features = []
            if (licenceAllocation.id) {
                features = licenceGroups.find(({ id }) => id === licenceAllocation.groupId)?.feature ?? []
            }

            setLicenceFeatures(features)
            console.log('licenceFeatures', licenceFeatures)
        }
    }, [props.show])

    const changeLicence = ({ value, name }) => {
        const licenceGroup = licenceGroups.find(({ id }) => id === value)
        setLicenceFeatures(licenceGroup.feature)
        console.log('licenceFeatures', licenceGroup)
        store.updateLicenceAllocation({ value: licenceGroup.id, name })
    }

    return (
        <Modal
            show={show}
            onClose={() => store.toggleModal('licenceAllocation')}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                }}
            >
                {/*
                    Either filter licence groups or products by productType depending on preferred flow
                */}
                <Select
                    label="Licence group"
                    name="groupId"
                    options={store.getLicenceGroupsForAllocation(licenceAllocation.productId)}
                    onBlur={changeLicence}
                    defaultValue={licenceAllocation.groupId}
                />

                <Select
                    label="Product"
                    name="productId"
                    options={clientProducts}
                    defaultValue={licenceAllocation.productId}
                    onBlur={store.updateLicenceAllocation}
                />

                <Switch
                    label="Licence excempt"
                    name="licenceExcempt"
                    isLeft
                    onToggle={(value) => store.updateLicenceAllocation({ value, name: 'licenceExcempt' })}
                    state={licenceAllocation.licenceExcempt}
                />

                {Boolean(licenceAllocation.licenceExcempt) && (
                    <Input
                        onBlur={store.updateLicenceAllocation}
                        label="Licence excempt reason"
                        name="licenceExcemptReason"
                        defaultValue={licenceAllocation.licenceExcemptReason}
                    />
                )}

                <div
                    className="form-checkbox-grp"
                >
                    <label className="checkbox-grp-label">
                        Licence group feature flags
                    </label>
                    {store.licenceAddons
                        .filter(({ value }) => licenceFeatures.includes(value))
                        .map(({ label }) => (
                            <div>{label}</div>
                        ))}
                </div>

                <CheckboxGroup
                    onBlur={store.updateLicenceAllocation}
                    refreshOnRender
                    label="Feature flags"
                    name="feature"
                    returnValueUnchanged
                    defaultChecked={licenceAllocation.feature}
                    options={store.licenceAddons
                        .filter(({ value }) => !licenceFeatures.includes(value))}
                />

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <Button
                        label="Cancel"
                        variant="tertiary"
                        cssClass="regular"
                        onClick={() => store.toggleModal('licenceAllocation')}
                    />

                    <Button
                        label="Save"
                        variant="primary"
                        cssClass="regular"
                        onClick={store.saveLicenceAllocation}
                    />
                </div>
            </div>
        </Modal>
    )
    // }
})

export default LicenceAllocation
